import { createFileRoute } from '@tanstack/react-router';

/**
 * 홈 라우트 (/)
 *
 * TanStack Router의 autoCodeSplitting이 활성화되어 있으므로,
 * 컴포넌트는 index.lazy.tsx에서 자동으로 코드 스플리팅됩니다.
 */
export const Route = createFileRoute('/')({});
